const RouteNumbers = () => import("./views/RouteNumbers.vue");
const RouteNumberEdit = () => import("./views/RouteNumberEdit.vue");

const route = "/routeNumbers";

export default [
  {
    path: route,
    name: "routeNumbers.list",
    component: RouteNumbers,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "routeNumbers.create",
    component: RouteNumberEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:routeNumberId/edit`,
    name: "routeNumbers.edit",
    component: RouteNumberEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
